// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useMutation, useMutationState } from '@tanstack/react-query';
import { useHttpClient } from '@toggl/sync/http';
import type { CareersPatchPage } from '../types';
import type { MutationOptions } from '../utils/mutations';
import {
  patchCareersPageMutationKey,
  postCareersPageSubdomainAvailableMutationKey,
} from './keys';
import {
  patchCareersPage,
  postCareersPageSubdomainAvailable,
} from './requests';

export type PatchCareersPageMutationVariables = {
  workspaceId: number;
  data: Partial<CareersPatchPage>;
};

export type PatchCareersPageMutationOptions<TContext = unknown> =
  MutationOptions<
    typeof patchCareersPage,
    PatchCareersPageMutationVariables,
    TContext
  >;

/**
 * Patch careers page contents of workspace.
 */
export function usePatchCareersPageMutation<TContext = unknown>(
  options: PatchCareersPageMutationOptions<TContext> = {}
) {
  const httpClient = useHttpClient();
  return useMutation({
    mutationFn: ({ workspaceId, data }) =>
      patchCareersPage(httpClient, workspaceId, data),
    mutationKey: patchCareersPageMutationKey,
    ...options,
  });
}

/** Returns the variables of a pending patchCareersPage mutation. */
export function usePatchCareersPageMutationVariables() {
  return useMutationState({
    filters: { mutationKey: patchCareersPageMutationKey, status: 'pending' },
    select: (mutation) =>
      mutation.state.variables as PatchCareersPageMutationVariables,
  });
}

export type PostCareersPageSubdomainAvailableMutationVariables = {
  workspaceId: number;
  data: string;
};

export type PostCareersPageSubdomainAvailableMutationOptions<
  TContext = unknown,
> = MutationOptions<
  typeof postCareersPageSubdomainAvailable,
  PostCareersPageSubdomainAvailableMutationVariables,
  TContext
>;

/**
 * Checks whether given subdomain is available.
 */
export function usePostCareersPageSubdomainAvailableMutation<
  TContext = unknown,
>(options: PostCareersPageSubdomainAvailableMutationOptions<TContext> = {}) {
  const httpClient = useHttpClient();
  return useMutation({
    mutationFn: ({ workspaceId, data }) =>
      postCareersPageSubdomainAvailable(httpClient, workspaceId, data),
    mutationKey: postCareersPageSubdomainAvailableMutationKey,
    ...options,
  });
}

/** Returns the variables of a pending postCareersPageSubdomainAvailable mutation. */
export function usePostCareersPageSubdomainAvailableMutationVariables() {
  return useMutationState({
    filters: {
      mutationKey: postCareersPageSubdomainAvailableMutationKey,
      status: 'pending',
    },
    select: (mutation) =>
      mutation.state
        .variables as PostCareersPageSubdomainAvailableMutationVariables,
  });
}
